module.exports = __webpack_public_path__ + "static/media/icon-biberon.5870daf3.svg";